export const useClient = <T>(
	action: Function,
	defaultValue?: T,
): T | undefined => {
	// @ts-ignore
	if (process.client) {
		return action(null);
	}
	return defaultValue;
};

export const useClientGetAllAttendant = async () => {
	return await useGet(
		`/client/get-all-attendant`
	);
};